import React from 'react';
import styled from 'styled-components';

import { useStore } from '../../context/appContext';
// assets
import DocumentFront from '../../assets/img/DocumentFront.png';
import DocumentBack from '../../assets/img/DocumentBack.png';
import { CAMERA_ACCESS_ERROR, CAMERA_TYPE_BACK, CAMERA_TYPE_FRONT } from '../../constants/selfieTypes';

const MainContainer = styled.div`
  grid-area: content;
  margin-top: 1rem;
  display: grid;
  grid-template-rows: auto 1fr 1fr;
  grid-template-areas:
    'text'
    'front'
    'back';
  grid-row-gap: 1rem;
  justify-content: center;
  justify-items: center;
  align-content: space-around;
  align-items: space-between;
  text-align: center;
`;

const DescriptionText = styled.div`
  grid-area: text;
  text-align: center;
  font-size: 0.9rem;
`;

const FrontDocumentContainer = styled.div`
  grid-area: front;
  border-radius: 20px;
  border: 3px ${(p) => p.theme.primary} solid;
  height: 85%;
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;

const BackDocumentContainer = styled.div`
  grid-area: back;
  border-radius: 20px;
  border: 3px ${(p) => p.theme.primary} solid;
  height: 85%;
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;

const DocumentImgContainer = styled.div`
  margin-top: 0.5rem;
  width: 60%;
`;

const DocumentImg = styled.img`
  height: 100%;
`;

const DescriptionTextContainer = styled.div`
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  padding-top: 0.6rem;
  padding-bottom: 1.7rem;
`;

const DocumentText = styled.p`
  font-size: 0.9rem;
`;

const Bluespan = styled.span`
  color: ${(p) => p.theme.primary};
  font-weight: 800;
`;

const ImgPreview = styled.img`
  padding: 0.1rem;
  border-radius: 20px;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border: 2px ${(p) => p.theme.accent} solid;
`;
function DocumentCamera() {
  const { setCamera, photosUri, setError } = useStore();
  
  const cameraPermissions = (type) => {
    setCamera({
      open: true,
      type: type,
    });
  }
  const handleDocumentFrontPhoto = () => {
    cameraPermissions(CAMERA_TYPE_FRONT)
  };
  const handleDocumentBackPhoto = () => {
    cameraPermissions(CAMERA_TYPE_BACK)
  };

  return (
    <MainContainer>
      <DescriptionText>
        Presioná en los recuadros para tomar cada fotografía.
      </DescriptionText>
      <FrontDocumentContainer onClick={handleDocumentFrontPhoto}>
        {photosUri.front ? (
          <ImgPreview src={photosUri.front} alt="document front photo" />
        ) : (
          <>
            <DocumentImgContainer>
              <DocumentImg src={DocumentFront} />
            </DocumentImgContainer>
            <DescriptionTextContainer>
              <DocumentText>
                <Bluespan>Presioná</Bluespan> para tomar la foto del{' '}
                <Bluespan>frente</Bluespan> de tu DNI
              </DocumentText>
            </DescriptionTextContainer>
          </>
        )}
      </FrontDocumentContainer>
      <BackDocumentContainer onClick={handleDocumentBackPhoto}>
        {photosUri.back ? (
          <ImgPreview src={photosUri.back} />
        ) : (
          <>
            <DocumentImgContainer>
              <DocumentImg src={DocumentBack} alt="document back photo" />
            </DocumentImgContainer>
            <DescriptionTextContainer>
              <DocumentText>
                <Bluespan>Presioná</Bluespan> para tomar la foto del{' '}
                <Bluespan>dorso</Bluespan> de tu DNI
              </DocumentText>
            </DescriptionTextContainer>
          </>
        )}
      </BackDocumentContainer>
    </MainContainer>
  );
}

export default DocumentCamera;
